import logger from 'utils/logger.util';
import isNotFn from 'utils/predicates/function/isNotFn.util';

const L = logger('focusElement');

const focusElement = (element) => {
  if (!element) return element;

  if (isNotFn(element.focus)) {
    L.warn('The element:', element, 'has no valid focus function');
    return element;
  }

  element.focus();

  return element;
};

// noinspection JSUnusedGlobalSymbols
export default focusElement;
